import React from "react";
import PropTypes from "prop-types";

import IntlMenu from "../intl-menu";
import Link from "../../link";
import SVG from "../../svg";
import { login, logout, isAuthenticated } from "../../../utils/auth";

import { formatPagePath } from "../../../utils";

import { outer_container, container, left_side, right_side, auth_link } from "./styles.module.scss";

const UtilityNavigation = ({ featured_media, links, hasAuth }) => {
  const handleLogout = (e) => {
    logout();
    e.preventDefault();
  };

  const handleLogin = (e) => {
    login();
    e.preventDefault();
  };

  return (
    <div className={outer_container}>
      <div className={container}>
        <div className={left_side}>
          {featured_media && (
            <Link
              label={featured_media.linkText || featured_media.link_text}
              to={
                featured_media.page?.data ? formatPagePath(featured_media.page) : featured_media.url
              }
              onClick={featured_media.onClick}
              newWindow={featured_media.new_window}
            >
              {featured_media.link_text}
              <SVG name="angle-right" />
            </Link>
          )}
        </div>
        <div className={right_side}>
          {hasAuth && isAuthenticated() ? (
            <Link className={auth_link} label="Sign out" to="#logout" onClick={handleLogout}>
              Sign out
              <SVG name="sign-out" />
            </Link>
          ) : (
            <>
              <span>Have a Secure Site account?</span>

              <Link className={auth_link} label="Sign in" to="#login" onClick={handleLogin}>
                Sign in
                <SVG name="sign-in" />
              </Link>
            </>
          )}

          {!hasAuth &&
            links &&
            links.map((link, index) => (
              <Link
                label={link.linkText || link.link_text}
                to={link.page ? formatPagePath(link.page) : link.url}
                onClick={link.onClick}
                newWindow={link.new_window}
                key={index}
              >
                {link.link_text}
              </Link>
            ))}

          {process.env.GATSBY_STRAPI_LOCALE && <IntlMenu />}
        </div>
      </div>
    </div>
  );
};

UtilityNavigation.propTypes = {
  featured_media: PropTypes.object,
  links: PropTypes.array,
  hasAuth: PropTypes.bool
};

export default UtilityNavigation;
